import React, { useState, useEffect, useCallback, useRef } from "react";
import {
    Container, Row, Col, Form, Card, Button, Breadcrumb, Table,
    Modal, Badge, Pagination, Spinner,
} from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getAllLeaveTypes, getLeaveAllotmentsByCriteria } from "../../../../api/onboarddeboard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
    applyLeave,
    editLeave,
    getMyLeaves,

    getHandoverOptions,
    getLeaveDocument,
    getMyLeaveEmployeeId,
    getAllLeaveSetups,
} from "../../../../api/onboarddeboard";


const fmtDate = (d) => {
    if (!d) return "-";
    const dt = new Date(d);
    if (isNaN(dt)) return d;
    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yyyy = dt.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
};
const getJoiningDate = (toDate) => {
    if (!toDate) return "-";
    const [y, m, d] = String(toDate).split("T")[0].split("-").map(Number);
    if (!y || !m || !d) return "-";
    return fmtDate(new Date(y, m - 1, d + 1));
};
// First Half (Forenoon) leave: employee rejoins in the afternoon of the same day
const getLeaveJoiningDate = (l) =>
    l.dayType === "HALF" && l.halfDaySession === "FIRST_HALF"
        ? fmtDate(l.fromDate)
        : getJoiningDate(l.toDate);
const STATUS_VARIANT = { PENDING: "warning", APPROVED: "success", REJECTED: "danger", CANCELLED: "secondary" };
const ITEMS_PER_PAGE = 20;
const emptyForm = { leaveTypeId: "", dayType: "FULL", fromDate: "", toDate: "", halfDaySession: "", reason: "", address: "", handoverUserId: "" };
const getIsDocumentRequired = (leaveTypesArr, leaveTypeId) => {
    const t = leaveTypesArr.find((lt) => String(lt.id) === String(leaveTypeId));
    return t?.documentCompulsory === true;
};
const getIsHandoverRequired = (leaveTypesArr, leaveTypeId) => {
    const t = leaveTypesArr.find((lt) => String(lt.id) === String(leaveTypeId));
    return t?.mandatoryChargeHandover === true;
};
const getIsHandoverRequiredFromSetup = (setupsArr, leaveTypeId) => {
    if (!leaveTypeId) return false;
    const setup = setupsArr.find(
        (s) => String(s.leaveType?.id) === String(leaveTypeId) && s.status !== false
    );
    return setup?.mandatoryChargeHandover === true;
};
const getReasonError = (value) => {
    const trimmedValue = value.trim();

    if (/^\s+$/.test(value)) {
        return "Reason cannot be only spaces.";
    }

    if (!trimmedValue) {
        return "Reason is required.";
    }

    if (/^\d+$/.test(trimmedValue)) {
        return "Reason cannot be only numeric.";
    }

    if (/^[^a-zA-Z0-9]+$/.test(trimmedValue)) {
        return "Reason cannot be only special characters.";
    }

    if (
        /^[^a-zA-Z]*$/.test(trimmedValue) &&
        /[0-9]/.test(trimmedValue) &&
        /[^a-zA-Z0-9]/.test(trimmedValue)
    ) {
        return "Reason cannot be only numbers and special characters.";
    }

    return "";
};
const validateRequired = (form, document, leaveTypes, leaveSetups, hasExistingDocument) => {
    const errors = {};
    if (!form.leaveTypeId) errors.leaveTypeId = "Leave type is required.";
    if (!form.fromDate) errors.fromDate = "From date is required.";
      if (form.dayType === "HALF") {
        if (!form.halfDaySession) errors.halfDaySession = "Please select First Half or Second Half.";
    } else if (!form.toDate) {
        errors.toDate = "To date is required.";
    }

    const reasonErr = getReasonError(form.reason);
    if (reasonErr) errors.reason = reasonErr;

    const selectedLeaveType = leaveTypes.find((t) => String(t.id) === String(form.leaveTypeId));

    const isDocRequiredNow = selectedLeaveType?.documentCompulsory === true;
    if (isDocRequiredNow && !document && !hasExistingDocument) {
        errors.document = "Supporting document is required for this leave type.";
    }

    const isHandoverRequiredNow =
        selectedLeaveType?.mandatoryChargeHandover === true ||
        getIsHandoverRequiredFromSetup(leaveSetups, form.leaveTypeId);
    if (isHandoverRequiredNow && !form.handoverUserId) {
        errors.handoverUserId = "Handover in-charge is required for this leave type.";
    }

    return errors;
};
const EmployeeLeaveApplication = () => {
    const token = localStorage.getItem("token");
    const [currentEmployeeId, setCurrentEmployeeId] = useState(null);

    useEffect(() => {
        if (!token) return;

        getMyLeaveEmployeeId(token)
            .then((r) => {
                console.log("getMyLeaveEmployeeId response:", r.data);
                console.log("Setting currentEmployeeId to:", r.data.employeeId);
                setCurrentEmployeeId(r.data.employeeId);
            })
            .catch((err) => {
                console.log("getMyLeaveEmployeeId error:", err);
                setCurrentEmployeeId(null);
            });
    }, [token]);


    const [leaveTypes, setLeaveTypes] = useState([]);
    const [handoverOptions, setHandoverOptions] = useState([]);
    const [allotments, setAllotments] = useState([]);
    const [myLeaves, setMyLeaves] = useState([]);
    const [loadingCards, setLoadingCards] = useState(false);
    const [leaveSetups, setLeaveSetups] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [form, setForm] = useState(emptyForm);
    const [document, setDocumentFile] = useState(null);
    const [existingDocumentName, setExistingDocumentName] = useState(null);
    const fileInputRef = useRef(null);
    const [submitting, setSubmitting] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    const [showEditWarning, setShowEditWarning] = useState(false);
    const [pendingEdit, setPendingEdit] = useState(null);

    const [showDocModal, setShowDocModal] = useState(false);
    const [docUrl, setDocUrl] = useState(null);
    const [docType, setDocType] = useState("");

    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("ALL");
    const [sortField, setSortField] = useState("createdAt");
    const [currentPage, setCurrentPage] = useState(1);

    //   const loadMyLeaves = useCallback(() => {
    //     getMyLeaves(token).then((r) => setMyLeaves(r.data || [])).catch(() => toast.error("Failed to load your leave applications."));
    //   }, [token]);

    const loadMyLeaves = useCallback(() => {
        getMyLeaves(token)
            .then((r) => {
                console.log("getMyLeaves response:", r.data);
                setMyLeaves(r.data || []);
            })
            .catch((err) => {
                console.log("getMyLeaves error:", err);
                toast.error("Failed to load your leave applications.");
            });
    }, [token]);

    const loadAllotments = useCallback(() => {
        const year = new Date().getFullYear();
        getLeaveAllotmentsByCriteria({ year }, token)
            .then((r) => {
                console.log("allotments response:", r.data);
                setAllotments(r.data || []);
            })
            .catch((err) => {
                console.log("allotments error:", err);
            });
    }, [token]);
    useEffect(() => {
        if (!token) return;
        setLoadingCards(true);
        getAllLeaveTypes(token)
            .then((r) => setLeaveTypes((r.data || []).filter((t) => t.status)))
            .catch(() => toast.error("Failed to load leave types."))
            .finally(() => setLoadingCards(false));
        getHandoverOptions(token).then((r) => setHandoverOptions(r.data || [])).catch(() => { });
        getAllLeaveSetups(token)                                          // ADD THIS BLOCK
            .then((r) => setLeaveSetups(r?.data?.data || r?.data || []))
            .catch(() => { });
        loadMyLeaves();
        loadAllotments();
    }, [token, loadMyLeaves, loadAllotments]);

    const getLeaveStats = (leaveTypeId) => {
        const apps = myLeaves.filter((a) => String(a.leaveTypeId) === String(leaveTypeId));
        const sumDays = (list) => list.reduce((sum, a) => sum + (Number(a.totalDays) || 0), 0);
        return {
            total: sumDays(apps),
            pending: sumDays(apps.filter((a) => a.status === "PENDING")),
            approved: sumDays(apps.filter((a) => a.status === "APPROVED")),
            rejected: sumDays(apps.filter((a) => a.status === "REJECTED")),
        };
    };

       const getBalance = (leaveTypeId) => {
        if (!currentEmployeeId) return null;
        const matching = allotments.filter(
            (a) => String(a.employee?.id) === String(currentEmployeeId) && String(a.leaveName?.id) === String(leaveTypeId)
        );
        console.log("DEBUG getBalance:", { leaveTypeId, currentEmployeeId, matchingCount: matching.length, matching, allotmentsLength: allotments.length });
        if (matching.length === 0) return null;
        return matching.reduce((sum, a) => sum + (a.totalBalance || 0), 0);
    };

    const openApply = (leaveTypeId) => {
        const balance = leaveTypeId ? getBalance(leaveTypeId) : null;
        if (leaveTypeId) {
            if (balance === null) { toast.error("Opening balance not found, contact your administrator."); return; }
            if (balance <= 0) { toast.error("Your opening balance is 0, you cannot apply for this leave."); return; }
        }
        setEditingId(null);
        setForm({ ...emptyForm, leaveTypeId: leaveTypeId || "" });
        setDocumentFile(null);
        setExistingDocumentName(null);
        setFormErrors({});
        setShowModal(true);
    };

    const applyEdit = (leave) => {
        setEditingId(leave.id);
        setForm({
            leaveTypeId: leave.leaveTypeId || "",
            dayType: leave.dayType === "HALF" ? "HALF" : "FULL",
            halfDaySession: leave.halfDaySession || "",
            fromDate: leave.fromDate || "",
            toDate: leave.dayType === "HALF" ? "" : (leave.toDate || ""),
            reason: leave.reason || "",
            address: leave.address || "",
            handoverUserId: leave.handoverUserId || "",
        });
        setDocumentFile(null);
        setExistingDocumentName(leave.documentName || null);
        setFormErrors({});
        setShowModal(true);
    };
    const handleEditClick = (leave) => {
        if (leave.status !== "PENDING") {
            setPendingEdit(leave);
            setShowEditWarning(true);
        } else {
            applyEdit(leave);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const requiredErrors = validateRequired(form, document, leaveTypes, leaveSetups, !!existingDocumentName);
        setFormErrors((prev) => ({ ...prev, ...requiredErrors }));
        if (Object.keys(requiredErrors).length > 0) {
            return;
        }

        const isHalf = form.dayType === "HALF";
        const effectiveToDate = isHalf ? form.fromDate : form.toDate;

        const today = new Date(); today.setHours(0, 0, 0, 0);
        const from = new Date(form.fromDate);
        const to = new Date(effectiveToDate);
        if (from < today) { toast.error("From date cannot be in the past."); return; }
        if (to < from) { toast.error("To date cannot be before from date."); return; }

        const data = new FormData();
        data.append(
            "data",
            new Blob([JSON.stringify({
                leaveTypeId: form.leaveTypeId,
                dayType: form.dayType,
                halfDaySession: isHalf ? form.halfDaySession : null,
                fromDate: form.fromDate,
                toDate: effectiveToDate,
                reason: form.reason,
                address: form.address,
                handoverUserId: form.handoverUserId || null,
            })], { type: "application/json" })
        );
        if (document) data.append("document", document);

        setSubmitting(true);
        try {
            if (editingId) {
                await editLeave(editingId, data, token);
                toast.success("Leave application updated successfully.");
            } else {
                await applyLeave(data, token);
                toast.success("Leave applied successfully.");
            }
            setShowModal(false);
            loadMyLeaves();
            loadAllotments();
        } catch (err) {
            console.log("applyLeave error:", err);
            console.log("status:", err?.response?.status);
            console.log("data type:", typeof err?.response?.data);
            console.log("data value:", err?.response?.data);

            let backendMsg = "";
            const data = err?.response?.data;

            if (typeof data === "string") {
                backendMsg = data;
            } else if (data instanceof Blob) {
                try {
                    const text = await data.text();
                    try {
                        const parsed = JSON.parse(text);
                        backendMsg = parsed.message || parsed.error || text;
                    } catch {
                        backendMsg = text;
                    }
                } catch {
                    backendMsg = "";
                }
            } else if (data?.message) {
                backendMsg = data.message;
            } else if (data?.error) {
                backendMsg = data.error;
            } else if (Array.isArray(data?.errors) && data.errors.length) {
                backendMsg = data.errors[0]?.message || data.errors[0];
            }

            toast.error(backendMsg || "Something went wrong. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };

    const handleViewDocument = async (id) => {
        try {
            const res = await getLeaveDocument(id, token);
            setDocUrl(URL.createObjectURL(res.data));
            setDocType(res.data.type);
            setShowDocModal(true);
        } catch {
            toast.error("Failed to load document.");
        }
    };
    const closeDocModal = () => {
        if (docUrl) URL.revokeObjectURL(docUrl);
        setDocUrl(null); setDocType(""); setShowDocModal(false);
    };

    const handleExportCSV = () => {
        const headers = ["Leave Type", "From", "To", "Days", "Reason", "Status"];
        let csv = headers.join(",") + "\n";
        filteredLeaves.forEach((l) => {
            csv += [l.leaveTypeName, l.fromDate, l.toDate, l.totalDays, l.reason, l.status].map((c) => `"${c ?? ""}"`).join(",") + "\n";
        });
        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = window.document.createElement("a");
        a.href = url; a.download = `my-leave-applications-${new Date().toISOString().split("T")[0]}.csv`;
        a.click(); URL.revokeObjectURL(url);
    };

    let filteredLeaves = [...myLeaves];
    if (search.trim()) {
        const q = search.toLowerCase();
        filteredLeaves = filteredLeaves.filter((l) => l.leaveTypeName?.toLowerCase().includes(q) || l.reason?.toLowerCase().includes(q));
    }
    if (statusFilter !== "ALL") filteredLeaves = filteredLeaves.filter((l) => l.status === statusFilter);
    if (sortField === "createdAt") filteredLeaves.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    else if (sortField === "fromDate") filteredLeaves.sort((a, b) => new Date(b.fromDate) - new Date(a.fromDate));
    else if (sortField === "status") filteredLeaves.sort((a, b) => a.status.localeCompare(b.status));

    const totalPages = Math.ceil(filteredLeaves.length / ITEMS_PER_PAGE);
    const paginated = filteredLeaves.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

    const calculatedTotalDays = (() => {
        if (form.dayType === "HALF") return form.fromDate ? 0.5 : null;
        if (!form.fromDate || !form.toDate) return null;
        const from = new Date(form.fromDate);
        const to = new Date(form.toDate);
        if (isNaN(from) || isNaN(to) || to < from) return null;
        const diffMs = to.setHours(0, 0, 0, 0) - from.setHours(0, 0, 0, 0);
        return Math.round(diffMs / (1000 * 60 * 60 * 24)) + 1;
    })();

const calculatedJoiningDate = (() => {
    const baseDate = form.dayType === "HALF" ? form.fromDate : form.toDate;
    if (!baseDate) return null;
    const [y, m, d] = baseDate.split("-").map(Number);
    if (!y || !m || !d) return null;
    const isFirstHalf = form.dayType === "HALF" && form.halfDaySession === "FIRST_HALF";
    return fmtDate(new Date(y, m - 1, isFirstHalf ? d : d + 1));
})();
    const isDocumentRequired = getIsDocumentRequired(leaveTypes, form.leaveTypeId);
    const isHandoverRequired =
        getIsHandoverRequired(leaveTypes, form.leaveTypeId) ||
        getIsHandoverRequiredFromSetup(leaveSetups, form.leaveTypeId);

    return (
        <Container fluid className="p-4">
            <style>{`
        .lc-breadcrumb a { text-decoration: none !important; color: #2E5CB8 !important; }
        .lc-breadcrumb .breadcrumb-item.active { color: #6c757d !important; }
        .pagination .page-item.active .page-link { background-color: #2E5CB8 !important; border-color: #2E5CB8 !important; }
        .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--selected) {
          background-color: transparent !important;
          color: #000 !important;
          font-weight: normal !important;
        }
        .modal-body .form-check-input[type="radio"] {
          width: 0.7em;
          height: 0.7em;
          margin-top: 0.4em;
        }
        .modal-body .form-check {
          padding-left: calc(1.5em + 8px);
        }
      `}</style>
            <ToastContainer position="top-right" autoClose={3000} />

            <Row className="align-items-center">
                <Col>
                    <h4 className="page-main-heading" style={{ marginBottom: 12 }}>Employee Leave Application</h4>
                </Col>

            </Row>

            <Breadcrumb className="lc-breadcrumb">
                <Breadcrumb.Item href="#">Leave</Breadcrumb.Item>
                <Breadcrumb.Item href="#">Leave Application</Breadcrumb.Item>
                <Breadcrumb.Item active>Employee Leave Application</Breadcrumb.Item>
            </Breadcrumb>

            <p className="text-muted mb-3" style={{ fontSize: 13 }}>Click on a leave type card to apply, or use the button above.</p>

            {/* ── Leave type cards ── */}
            <Row className="g-3 mb-4">
                {loadingCards ? (
                    <Col xs={12} className="text-center py-5"><Spinner animation="border" style={{ color: "#2E5CB8" }} /></Col>
                ) : leaveTypes.length === 0 ? (
                    <Col xs={12}>
                        <Card className="border-0 shadow-sm"><Card.Body className="text-center py-5 text-muted">No active leave types found.</Card.Body></Card>
                    </Col>
                ) : (
                    leaveTypes.map((leave) => {
                        const stats = getLeaveStats(leave.id);
                        const color = leave.color || "#2E5CB8";
                        const balance = getBalance(leave.id);
                        return (
                            <Col xl={3} lg={4} md={6} sm={12} key={leave.id}>
                                <Card
                                    className="h-100"
                                    style={{
                                        border: "1px solid #e5e7eb",
                                        borderLeft: `4px solid ${color}`,
                                        borderRadius: 16,
                                        cursor: "pointer",
                                        backgroundColor: "#ffffff",
                                        overflow: "hidden",
                                        boxShadow: "0 2px 8px rgba(15, 23, 42, 0.04)",
                                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                    }}
                                    onClick={() => openApply(leave.id)}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-2px)";
                                        e.currentTarget.style.boxShadow =
                                            "0 12px 30px rgba(15, 23, 42, 0.10)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow =
                                            "0 2px 8px rgba(15, 23, 42, 0.04)";
                                    }}
                                >
                                    <Card.Body
                                        style={{
                                            padding: "24px 24px 20px",
                                        }}
                                    >

                                        {/* ================= HEADER ================= */}
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "flex-start",
                                                gap: 16,
                                            }}
                                        >

                                            {/* LEFT CONTENT */}
                                            <div
                                                style={{
                                                    flex: 1,
                                                    minWidth: 0,
                                                }}
                                            >

                                                <h6
                                                    style={{
                                                        margin: 0,
                                                        fontSize: 19,
                                                        fontWeight: 700,
                                                        lineHeight: 1.3,
                                                        color: "#111827",
                                                        letterSpacing: "-0.02em",
                                                        wordBreak: "break-word",
                                                    }}
                                                >
                                                    {leave.leaveName}
                                                </h6>

                                                {/* EXISTING CONDITIONAL BADGES */}
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: 7,
                                                        marginTop: 22,
                                                    }}
                                                >

                                                    {leave.paidLeave && (
                                                        <span
                                                            style={{
                                                                backgroundColor: "#eaf7ee",
                                                                color: "#218739",
                                                                fontSize: 10,
                                                                fontWeight: 600,
                                                                padding: "6px 11px",
                                                                borderRadius: 20,
                                                                lineHeight: 1,
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            Paid
                                                        </span>
                                                    )}

                                                    {leave.yearly && (
                                                        <span
                                                            style={{
                                                                backgroundColor: "#e9f1ff",
                                                                color: "#2161c5",
                                                                fontSize: 10,
                                                                fontWeight: 600,
                                                                padding: "6px 11px",
                                                                borderRadius: 20,
                                                                lineHeight: 1,
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            Yearly
                                                        </span>
                                                    )}

                                                    {leave.documentCompulsory && (
                                                        <span
                                                            style={{
                                                                backgroundColor: "#fff4dc",
                                                                color: "#b77900",
                                                                fontSize: 10,
                                                                fontWeight: 600,
                                                                padding: "6px 11px",
                                                                borderRadius: 20,
                                                                lineHeight: 1,
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            Doc Required
                                                        </span>
                                                    )}

                                                    {leave.compensatoryLeave && (
                                                        <span
                                                            style={{
                                                                backgroundColor: "#eef0f3",
                                                                color: "#5f6673",
                                                                fontSize: 10,
                                                                fontWeight: 600,
                                                                padding: "6px 11px",
                                                                borderRadius: 20,
                                                                lineHeight: 1,
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            Compensatory
                                                        </span>
                                                    )}

                                                </div>

                                            </div>


                                            {/* ================= BALANCE ================= */}
                                            <div
                                                style={{
                                                    flexShrink: 0,
                                                    width: 76,
                                                    textAlign: "center",
                                                }}
                                            >

                                                <div
                                                    style={{
                                                        width: 56,
                                                        height: 56,
                                                        margin: "0 auto",
                                                        borderRadius: "50%",
                                                        backgroundColor: color,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: "#ffffff",
                                                        fontSize: String(balance ?? "-").length > 5 ? 15 : 20,
                                                        fontWeight: 700,
                                                        lineHeight: 1,
                                                        whiteSpace: "nowrap",
                                                        boxShadow: `0 7px 18px ${color}35`,
                                                    }}
                                                >
                                                    {balance === null ? "-" : balance}
                                                </div>

                                                <div
                                                    style={{
                                                        marginTop: 9,
                                                        fontSize: 10,
                                                        fontWeight: 600,
                                                        color: "#9ca3af",
                                                        letterSpacing: "0.03em",
                                                    }}
                                                >
                                                    BAL
                                                </div>

                                            </div>

                                        </div>


                                        {/* ================= DIVIDER ================= */}
                                        <div
                                            style={{
                                                height: 1,
                                                backgroundColor: "#eceef2",
                                                margin: "20px 0 18px",
                                            }}
                                        />


                                        {/* ================= STATISTICS ================= */}
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                                                width: "100%",
                                            }}
                                        >

                                            {[
                                                ["Applied", stats.total],
                                                ["Pending", stats.pending],
                                                ["Approved", stats.approved],
                                                ["Rejected", stats.rejected],
                                            ].map(([label, value], index) => (

                                                <div
                                                    key={label}
                                                    style={{
                                                        minWidth: 0,
                                                        textAlign: "center",
                                                        padding: "0 6px",
                                                        borderRight:
                                                            index < 3
                                                                ? "1px solid #e5e7eb"
                                                                : "none",
                                                    }}
                                                >

                                                    <div
                                                        style={{
                                                            fontSize: 21,
                                                            fontWeight: 700,
                                                            lineHeight: 1.2,
                                                            color:
                                                                label === "Applied"
                                                                    ? "#5630c9"
                                                                    : label === "Pending"
                                                                        ? "#d88900"
                                                                        : label === "Approved"
                                                                            ? "#218739"
                                                                            : "#c62f38",
                                                        }}
                                                    >
                                                        {value}
                                                    </div>

                                                    <div
                                                        style={{
                                                            marginTop: 7,
                                                            fontSize: 10,
                                                            fontWeight: 500,
                                                            color: "#737b88",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {label}
                                                    </div>

                                                </div>

                                            ))}

                                        </div>

                                    </Card.Body>
                                </Card>
                            </Col>
                        );
                    })
                )}
            </Row>

            {/* ── My applications table ── */}
            <Row className="mb-4">
                <Col xl={12}>
                    <Card>
                        <Card.Body>
                            <Row className="mb-3 d-flex justify-content-between align-items-center g-2">
                                <Col md="auto"><h5 className="mb-0">My Leave Applications</h5></Col>
                                <Col md="auto" className="d-flex gap-2">
                                    <Form.Control
                                        type="text"
                                        placeholder="Search leave type / reason"
                                        value={search}
                                        onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
                                        style={{ width: 220 }}
                                    />
                                    <Form.Select value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setCurrentPage(1); }} style={{ width: 150 }}>
                                        <option value="ALL">All Status</option>
                                        <option value="PENDING">Pending</option>
                                        <option value="APPROVED">Approved</option>
                                        <option value="REJECTED">Rejected</option>
                                        <option value="CANCELLED">Cancelled</option>
                                    </Form.Select>
                                    <Form.Select value={sortField} onChange={(e) => setSortField(e.target.value)} style={{ width: 170 }}>
                                        <option value="createdAt">Sort: Latest First</option>
                                        <option value="status">Sort: Status</option>
                                    </Form.Select>
                                    <i
                                        className="bi bi-download"
                                        title="Export CSV"
                                        style={{ fontSize: "1.3rem", cursor: "pointer", color: "#2E5CB8", alignSelf: "center" }}
                                        onClick={handleExportCSV}
                                    />
                                </Col>
                            </Row>

                            <Table bordered hover responsive>
                                <thead>
                                    <tr>
{["Sr.No", "Leave Type", "Application Date", "From Date", "To Date", "Days", "Joining Date", "Status", "Document", "Action"].map((h) => (                                            <th key={h} style={{ backgroundColor: "#2E5CB8", color: "white" }}>{h}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginated.length === 0 && (
                                        <tr><td colSpan={10} className="text-center text-muted py-4">No leave applications found.</td></tr>                                    )}
                                    {paginated.map((l, index) => (
                                        <tr key={l.id}>
                                            <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                                            <td><span className="badge" style={{ backgroundColor: l.leaveTypeColor || "#2E5CB8" }}>{l.leaveTypeName}</span></td>
                                            <td>{fmtDate(l.createdAt)}</td>
                                            <td>{fmtDate(l.fromDate)}</td>
                                            <td>{fmtDate(l.toDate)}</td>
                                            <td>
                                                {l.totalDays}
                                                {l.dayType === "HALF" && (
                                                    <div className="text-muted" style={{ fontSize: 11 }}>
                                                        {l.halfDaySession === "FIRST_HALF" ? "First Half" : "Second Half"}
                                                    </div>
                                                )}
                                            </td>
<td>{getLeaveJoiningDate(l)}</td>
<td><Badge bg={STATUS_VARIANT[l.status] || "secondary"}>{l.status}</Badge></td>                                            <td>
                                                {l.documentName ? (
                                                    <Button variant="link" size="sm" className="p-0" onClick={() => handleViewDocument(l.id)}>
                                                        <i className="bi bi-file-earmark-text fs-5" style={{ color: "#2E5CB8" }} />
                                                    </Button>
                                                ) : "—"}
                                            </td>
                                            <td>
                                                {l.status === "PENDING" ? (
                                                    <button
                                                        className="btn btn-secondary"
                                                        type="button"
                                                        style={{ padding: "5px 10px" }}
                                                        onClick={() => handleEditClick(l)}
                                                    >
                                                        <i className="bi bi-pencil-fill me-2" />Edit
                                                    </button>
                                                ) : "—"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            <div className="d-flex justify-content-end">
                                <Pagination>
                                    <Pagination.Prev onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                                    {[...Array(totalPages).keys()].map((n) => (
                                        <Pagination.Item key={n + 1} active={n + 1 === currentPage} onClick={() => setCurrentPage(n + 1)}>{n + 1}</Pagination.Item>
                                    ))}
                                    <Pagination.Next onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages || totalPages === 0} />
                                </Pagination>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
                        
            {/* ── Apply / Edit modal ── */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton><Modal.Title>{editingId ? "Edit Leave Application" : "Apply for Leave"}</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <Row className="g-3">
                            <Col md={6}>
                                <label>Leave Type <span style={{ color: 'red' }}>*</span></label>
                                <Form.Select
                                    value={form.leaveTypeId}
                                    onChange={(e) => {
                                        setForm({ ...form, leaveTypeId: e.target.value });
                                        setFormErrors((prev) => ({ ...prev, leaveTypeId: "" }));
                                    }}
                                    disabled={!!form.leaveTypeId}
                                >
                                    <option value="">Select leave type</option>
                                    {leaveTypes.map((t) => <option key={t.id} value={t.id}>{t.leaveName}</option>)}
                                </Form.Select>
                                {formErrors.leaveTypeId && <p style={{ color: "red", fontSize: "13px" }}>{formErrors.leaveTypeId}</p>}
                            </Col>
                            <Col md={6} className="ps-4">
                                <label>Leave Duration</label>
                                <div className="d-flex align-items-center gap-3" style={{ minHeight: 38 }}>
                                    <Form.Check
                                        inline className="m-0" type="radio" id="dayType-full" name="dayType" label="Full Day"
                                        checked={form.dayType === "FULL"}
                                        onChange={() => {
                                            setForm({ ...form, dayType: "FULL", halfDaySession: "" });
                                            setFormErrors((prev) => ({ ...prev, halfDaySession: "", toDate: "" }));
                                        }}
                                    />
                                    <Form.Check
                                        inline className="m-0" type="radio" id="dayType-half" name="dayType" label="Half Day"
                                        checked={form.dayType === "HALF"}
                                        onChange={() => {
                                            setForm({ ...form, dayType: "HALF", toDate: "" });
                                            setFormErrors((prev) => ({ ...prev, halfDaySession: "", toDate: "" }));
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row className="g-3 mt-0">
                            <Col md={6}>
  
    <Form.Label>From Date <span style={{color: 'red'}}>*</span></Form.Label>
   <DatePicker
    selected={form.fromDate ? new Date(form.fromDate) : null}
    onChange={(date) => {
        setForm({ ...form, fromDate: date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}` : "" });
        setFormErrors((prev) => ({ ...prev, fromDate: "" }));
    }}
    onChangeRaw={(e) => {
        const value = e.target.value;
        // allow only numbers and / (for dd/mm/yyyy)
        if (value && !/^[0-9/]*$/.test(value)) {
            e.preventDefault();
        }
    }}
    minDate={new Date()}  
    dateFormat="dd/MM/yyyy"
    className="form-control"
    wrapperClassName="d-block"
    placeholderText="dd/mm/yyyy"
/>
{formErrors.fromDate && <p style={{ color: "red", fontSize: "13px" }}>{formErrors.fromDate}</p>}
</Col>
{form.dayType === "HALF" ? (
    <Col md={6} className="ps-4">
        <Form.Label className="d-block">Half Day Session <span style={{ color: 'red' }}>*</span></Form.Label>
        <Form.Check
            type="radio" id="half-first" name="halfDaySession"
              label="First Half (Forenoon)"
            checked={form.halfDaySession === "FIRST_HALF"}
            onChange={() => {
                setForm({ ...form, halfDaySession: "FIRST_HALF" });
                setFormErrors((prev) => ({ ...prev, halfDaySession: "" }));
            }}
        />
        <Form.Check
            type="radio" id="half-second" name="halfDaySession"
            label="Second Half (Afternoon)"
            checked={form.halfDaySession === "SECOND_HALF"}
            onChange={() => {
                setForm({ ...form, halfDaySession: "SECOND_HALF" });
                setFormErrors((prev) => ({ ...prev, halfDaySession: "" }));
            }}
        />
        {formErrors.halfDaySession && <p style={{ color: "red", fontSize: "13px" }}>{formErrors.halfDaySession}</p>}
    </Col>
) : (
    <Col md={6}>
        <label>To Date <span style={{color: 'red'}}>*</span></label>
        <DatePicker
            selected={form.toDate ? new Date(form.toDate) : null}
            onChange={(date) => {
                setForm({ ...form, toDate: date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}` : "" });
                setFormErrors((prev) => ({ ...prev, toDate: "" }));
            }}
            minDate={form.fromDate ? new Date(form.fromDate) : new Date()}
            dateFormat="dd/MM/yyyy"
            className="form-control"
            wrapperClassName="d-block"
            placeholderText="dd/mm/yyyy"
        />
        {formErrors.toDate && <p style={{ color: "red", fontSize: "13px" }}>{formErrors.toDate}</p>}
    </Col>
)}
                            <Col md={6}>
                                <Form.Label>Total Days</Form.Label>
                                <Form.Control
                                    value={calculatedTotalDays !== null ? `${calculatedTotalDays} day${calculatedTotalDays <= 1 ? "" : "s"}` : ""}
                                    placeholder="—"
                                    disabled
                                    style={{ backgroundColor: "#f3f4f6" }}
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Label>Joining Date</Form.Label>
                                <Form.Control
                                    value={calculatedJoiningDate || ""}
                                    placeholder="—"
                                    disabled
                                    style={{ backgroundColor: "#f3f4f6" }}
                                />
                            </Col>
                            <Col md={12}>
                                <label>Reason <span style={{ color: 'red' }}>*</span></label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    value={form.reason}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setForm({ ...form, reason: value });
                                        const trimmedValue = value.trim();
                                        const isOnlyNumeric = /^\d+$/.test(trimmedValue);
                                        setFormErrors((prev) => ({
                                            ...prev,
                                            reason: isOnlyNumeric ? "Reason cannot be only numeric." : "",
                                        }));
                                    }}
                                />
                                {formErrors.reason && (
                                    <p style={{ color: "red", fontSize: "13px" }}>{formErrors.reason}</p>
                                )}
                            </Col>
                            <Col md={12}><Form.Label>Address During Leave</Form.Label><Form.Control value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></Col>
                            <Col md={12}>
                                <Form.Label>{isDocumentRequired ? <>Supporting Document <span style={{color: 'red'}}>*</span></> : "Supporting Document"}</Form.Label>
                                <div className="d-flex align-items-center gap-2 border rounded" style={{ padding: 2 }}>
                                    <Button
                                        variant="light"
                                        size="sm"
                                        type="button"
                                        style={{ border: "1px solid #ced4da" }}
                                        onClick={() => fileInputRef.current?.click()}
                                    >
                                        Choose File
                                    </Button>
                                    <span style={{ fontSize: 14, color: document || existingDocumentName ? "#212529" : "#6c757d" }}>
                                        {document ? document.name : existingDocumentName || "No file chosen"}
                                    </span>
                                    {editingId && existingDocumentName && !document && (
                                        <Button variant="link" size="sm" className="ms-auto me-2 p-0" onClick={() => handleViewDocument(editingId)}>View</Button>
                                    )}
                                </div>
                                <Form.Control
                                    ref={fileInputRef}
                                    type="file"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    className="d-none"
                                    onChange={(e) => {
                                        setDocumentFile(e.target.files[0]);
                                        setFormErrors((prev) => ({ ...prev, document: "" }));
                                    }}
                                />
                                <Form.Text muted>PDF, JPG or PNG — max 1MB.</Form.Text>
                                {formErrors.document && <p style={{ color: "red", fontSize: "13px" }}>{formErrors.document}</p>}
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                        <Button type="submit" style={{ backgroundColor: "#2E5CB8", borderColor: "#2E5CB8" }} disabled={submitting}>
                            {submitting ? "Saving..." : editingId ? "Update" : "Apply"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* ── Cannot-edit warning modal ── */}
            <Modal show={showEditWarning} onHide={() => setShowEditWarning(false)} centered>
                <Modal.Header closeButton><Modal.Title><i className="bi bi-exclamation-triangle-fill text-warning me-2" />Cannot Edit</Modal.Title></Modal.Header>
                <Modal.Body>
                    <p>This leave application is currently <strong>{pendingEdit?.status}</strong>.</p>
                    <p className="mb-0 text-muted">Only <strong>PENDING</strong> applications can be edited.</p>
                </Modal.Body>
                <Modal.Footer><Button style={{ backgroundColor: "#2E5CB8", borderColor: "#2E5CB8" }} onClick={() => { setShowEditWarning(false); setPendingEdit(null); }}>OK</Button></Modal.Footer>
            </Modal>

            {/* ── Document viewer modal ── */}
            <Modal show={showDocModal} onHide={closeDocModal} size="lg" centered>
                <Modal.Header closeButton><Modal.Title><i className="bi bi-file-earmark-text me-2" />Document Viewer</Modal.Title></Modal.Header>
                <Modal.Body style={{ maxHeight: "70vh", overflow: "auto", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {docUrl && (docType.startsWith("image/") ? (
                        <img src={docUrl} alt="Document" style={{ maxWidth: "100%", maxHeight: "60vh", objectFit: "contain" }} />
                    ) : (
                        <iframe src={docUrl} style={{ width: "100%", height: "60vh", border: "none" }} title="Document Viewer" />
                    ))}
                </Modal.Body>
                <Modal.Footer><Button variant="secondary" onClick={closeDocModal}>Close</Button></Modal.Footer>
            </Modal>
        </Container>
    );
};

export default EmployeeLeaveApplication;
